/**
 * Run a Firestore query across all regions and merge the results.
 * Returns a flat array of { id, _region, ...docData } objects.
 */
export const queryAllRegions = async (allRegionDbs, collectionPath, queryFn) => {
  if (!allRegionDbs) return [];
  const results = await Promise.allSettled(
    Object.entries(allRegionDbs).map(async ([regionCode, regionDb]) => {
      const ref = queryFn ? queryFn(regionDb) : regionDb.collection(collectionPath);
      const snapshot = await ref.get();
      return snapshot.docs.map((doc) => ({ id: doc.id, _region: regionCode, ...doc.data() }));
    })
  );
  return results
    .filter((r) => r.status === 'fulfilled')
    .flatMap((r) => r.value);
};
